import React from 'react';
import { compose, withState, setPropTypes } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DeleteDialog from '../molecules/DeleteDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  setPropTypes(propTypes),
  withState('openDialog', 'updateOpenDialog', false)
);

const button = enhance(
  ({
    classes,
    content,
    openDialog,
    updateOpenDialog,
    onClickAction,
    disabled
  }) => {
    const okAction = () => {
      updateOpenDialog(false);
      onClickAction();
    };
    return (
      <div>
        <Button
          variant="outlined"
          color="primary"
          className={[classes.button]}
          onClick={() => updateOpenDialog(true)}
          disabled={disabled}
        >
          {content}
        </Button>
        <DeleteDialog
          openDelete={openDialog}
          updateOpenDelete={updateOpenDialog}
          cancelAction={() => updateOpenDialog(false)}
          deleteAction={okAction}
          target="設定"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
